'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createButtonTheme = exports.applyStyle = exports.buttonStyle = undefined;
var _polished = require('polished');
var _themeUtilities = require('../theme-utilities');
var _themeUtilities2 = _interopRequireDefault(_themeUtilities);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var buttonStyle = exports.buttonStyle = function buttonStyle() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  return _themeUtilities2.default.apply(undefined, ['Button'].concat(styles));
};
var applyStyle = exports.applyStyle = function applyStyle(style, base) {
  var prominence = ['primary', 'secondary', 'warning', 'danger', 'selected'];
  var split = style.split('_');
  var baseStyle = split[0] + '_' + split[1];
  var status = split[2];
  if (typeof status !== 'undefined') {
    var _styles = prominence.reduce(function (acc, curr) {
      return Object.assign({}, acc, _defineProperty({}, baseStyle + '_' + curr + '_' + status, base[(0, _themeUtilities.addVariant)(baseStyle, curr)] || base[style] || base[baseStyle] || base['Button_color_' + curr] || base.Button_color));
    }, _defineProperty({}, style, base[style] || base[baseStyle] || base.Button_color));
    return _styles;
  }
  var styles = prominence.reduce(function (acc, curr) {
    return Object.assign({}, acc, _defineProperty({}, style + '_' + curr, base[style] || base['Button_color_' + curr] || base.Button_color));
  }, _defineProperty({}, style, base[style] || base.Button_color));
  return styles;
};

// This is a function that could be used to create button themes
// Our button theme is very complicated, with lots of variables, which would require a lot of manual overrides.
// This function will set any unset prominence styles to the base button style (rather than inheriting Marmalade styles).
// Example - if backGroundImage is set to none, all prominence backgroundImage will also be set to this,
// rather than inheriting our gradient backgrounds - if further styles are not provided.
var createButtonTheme = exports.createButtonTheme = function createButtonTheme(overrides) {
  var base = Object.assign({
    Button_color: '#000',
    Button_backgroundColor: '#FFF',
    Button_backgroundImage: 'none',
    Button_boxShadow: 'none'
  }, overrides);
  return Object.assign({}, applyStyle('Button_color', base), applyStyle('Button_color_hover', base), applyStyle('Button_borderColor', base), applyStyle('Button_borderColor_hover', base), applyStyle('Button_backgroundColor', base), applyStyle('Button_backgroundColor_hover', base), applyStyle('Button_backgroundImage', base), applyStyle('Button_backgroundImage_hover', base), applyStyle('Button_boxShadow', base), applyStyle('Button_boxShadow_hover', base), overrides);
};

// This creates a theme for button styles specifically.
// These are defaults - if button styles are set further up stream, they will take precedence
var buttonTheme = function buttonTheme(baseTheme) {
  return createButtonTheme(Object.assign({
    Button_color: baseTheme.colorPrimary,
    Button_color_primary: baseTheme.colorBlack,
    Button_color_secondary: baseTheme.colorBlack,
    Button_color_warning: baseTheme.colorBlack,
    Button_color_danger: baseTheme.colorBlack,
    Button_color_selected: baseTheme.colorBlack,
    Button_borderRadius: baseTheme.borderRadius,
    Button_borderWidth: '1px',
    Button_borderStyle: 'solid',
    Button_borderColor: baseTheme.colorGreyDark,
    Button_borderColor_primary: baseTheme.colorRed,
    Button_borderColor_secondary: (0, _polished.darken)(0.2, baseTheme.colorSecondary),
    Button_borderColor_warning: (0, _polished.darken)(0.2, baseTheme.colorWarning),
    Button_borderColor_danger: (0, _polished.darken)(0.2, baseTheme.colorDanger),
    Button_borderColor_selected: (0, _polished.darken)(0.2, baseTheme.colorSelected),
    Button_borderColor_hover: baseTheme.colorPrimary,
    Button_borderColor_primary_hover: baseTheme.colorRed,
    Button_borderColor_secondary_hover: (0, _polished.darken)(0.3, baseTheme.colorSecondary),
    Button_borderColor_warning_hover: (0, _polished.darken)(0.2, baseTheme.colorWarning),
    Button_borderColor_selected_hover: (0, _polished.darken)(0.2, baseTheme.colorSelected),
    Button_backgroundColor: baseTheme.colorWhite,
    Button_backgroundColor_primary: baseTheme.colorPrimaryLight,
    Button_backgroundColor_secondary: baseTheme.colorSecondaryLight,
    Button_backgroundColor_warning: baseTheme.colorWarning,
    Button_backgroundColor_danger: baseTheme.colorDanger,
    Button_backgroundColor_selected: baseTheme.colorSelected,
    Button_backgroundImage: 'linear-gradient(' + baseTheme.colorWhite + ', ' + baseTheme.colorBlueLight + ' 100%)',
    Button_backgroundImage_primary: 'linear-gradient(' + (0, _polished.lighten)(0.1, baseTheme.colorPrimaryLight) + ', ' + baseTheme.colorPrimary + ' 100%)',
    Button_backgroundImage_secondary: 'linear-gradient(' + (0, _polished.lighten)(0.15, baseTheme.colorSecondaryLight) + ', ' + baseTheme.colorSecondary + ' 100%)',
    Button_backgroundImage_warning: 'linear-gradient(' + (0, _polished.lighten)(0.15, baseTheme.colorWarning) + ', ' + baseTheme.colorWarning + ' 100%)',
    Button_backgroundImage_danger: 'linear-gradient(' + (0, _polished.lighten)(0.15, baseTheme.colorDanger) + ', ' + baseTheme.colorDanger + ' 100%)',
    Button_backgroundImage_selected: 'linear-gradient(' + (0, _polished.lighten)(0.15, baseTheme.colorSelected) + ', ' + baseTheme.colorSelected + ' 100%)',
    Button_backgroundImage_hover: 'none',
    Button_boxShadow_hover: '0 1px 2px ' + baseTheme.colorShadow
  }, baseTheme));
};
exports.default = {
  buttonTheme: buttonTheme,
  buttonStyle: buttonStyle,
  createButtonTheme: createButtonTheme
};